import React from 'react';
import PageList from '../../components/PageListAPI'
import { getDelivery, deleteDelivery } from '../../api/acceptance'
import { SLUGS } from 'src/enum/permissions.enum';
import { useCan } from 'src/hooks/useCan';

export default function AcceptanceDoc(props) {
  const can = useCan();
  return (
    <div className='App-paper'>
      <PageList
        name='deliveryDoc'
        title='Акты приемки материалов'
        columns={[
          { id: 'date', name: 'Дата создания', type: 'date', formatDate: 'LL' },
          { id: 'number', name: 'Номер накладной' },
          {
            id: 'typeRelated', name: 'тип', type: 'component', component: ({ obj }) => {
              switch (obj.typeRelated) {
                case 'purchasemtp': return 'материалы'
                case 'customer': return 'материалы'
                case 'movemtp': return 'склад'
                case 'purchaseequip': return 'оборудование';
                default: return ''
              }
            }
          },
          { id: 'name', name: 'Склад/Поставщик' },
          { id: 'dateAccept', name: 'Дата накладной', type: 'date', formatDate: 'DD.MM.YYYY' },
          { id: 'userName', name: 'Принял' },
        ]}
        createItem={can(SLUGS.PROJECT.DELIVERY.CREATE)}
        deleteItem={can(SLUGS.PROJECT.DELIVERY.DELETE)}
        loadAPI={{
          request: getDelivery,
          querty: {
            idProject: props.match.params.id
          }
        }}
        filterProps={[
          {
            arr: [{ value: 'purchasemtp', name: 'материалы' }, { value: 'movemtp', name: 'склад' }, { value: 'purchaseequip', name: 'оборудование' }],
            field: 'typeRelated',
            name: 'Тип',
            type: 'select'
          },
        ]}
        {...props}
        deleteAPI={deleteDelivery}
        headerInit={{
          sortBy: 'date',
          sortDirection: 'desc',
        }}
      />
    </div>
  )
}

